"use strict";
import ValidationInput from "../helpers/validationInput";
import axios from "axios";
import GlobalError from "../helpers/globalError";
import LoadRecaptcha from "../helpers/Loadrecaptcha";

export default class Form {
	/**
	 * Validation control on all input of a form
	 * @param formId - string
	 */
	validationForm(formId) {
		const form = document.querySelector(formId);
		const formElements = form.querySelectorAll('.input-validation');
		form.querySelector(`button[type=submit]`).disabled = true;

		formElements.forEach(function (inputParent) {
			{
				const inputElement = inputParent.querySelector('.form-control');
				if (inputElement.type !== 'checkbox' || inputElement.type !== 'radio') {
					ValidationInput.resetInput(inputElement);
					inputElement.classList.remove('is-invalid');

					if(inputElement.dataset.showCriteria){
						inputElement.addEventListener('focus', (event) => {
							ValidationInput.showCriteria(event.target, form.id);
						});

						inputElement.addEventListener('keyup', (event) => {
							ValidationInput.checkInput(event.target, form.id);
						});

						inputElement.addEventListener('blur', (event) => {
							ValidationInput.inputHandling(event.target);
						});
					} else {
						inputElement.addEventListener('blur', (event) => {
							ValidationInput.validateInput(event.target, form.id);
						});
					}

					inputElement.addEventListener('invalid', (event) => {
						ValidationInput.resetInput(event.target);
					});
				}
				
			}
		});
	}
	
	/**
	 * Validation control only for username or email on the same field
	 * @param formId - string
	 */
	validationUsernameOrEmailInput(formId) {
		const form = document.querySelector(formId);
		const containerInput = form.querySelector('.input-validation');
		const inputElement = containerInput.querySelector('.form-control');
		const emailRegex = new RegExp(/[a-z\d._%+-]+@[a-z\d.-]+\.[a-z]{2,4}$/);
		const errorElement = document.querySelector(`.invalid-feedback.error-${ inputElement.id }`);
		
		ValidationInput.disableSubmitBtn(form.id);
		
		inputElement.addEventListener('blur', (event) => {
			if (/@/.test(event.target.value) && !event.target.value.match(emailRegex)) {
				inputElement.classList.add('is-invalid');
				errorElement.textContent = form.dataset.inputInvalidmailKey;
				ValidationInput.disableSubmitBtn(form.id);
			} else {
				ValidationInput.validateInput(event.target, form.id);
			}
		});
		
		inputElement.addEventListener('invalid', (event) => {
			ValidationInput.resetInput(event.target);
		});
		
	}
	
	/**
	 * Validation control only for complexity password input
	 * @param formId - string
	 * @param inputId - string input password id
	 */
	validationComplexPasswordInput(formId, inputId) {
		const form = document.querySelector(formId);
		const inputElement = document.querySelector(inputId);
		if(inputElement.dataset.showCriteria){
			return;
		}

		ValidationInput.disableSubmitBtn(form.id);
		
		inputElement.addEventListener('blur', (event) => {
			if (event.target.value.length !== 0) {
				ValidationInput.validatePasswordInput(event.target, form.id);
			} else {
				event.target.classList.remove('was-validated');
				ValidationInput.validateInput(event.target, form.id);
			}
		});
		
		inputElement.addEventListener('invalid', (event) => {
			ValidationInput.resetInput(event.target);
		});
	}
	
	/**
	 * Validation control only for confirm password input
	 * @param formId - string
	 * @param passwordInputId - string - input password id
	 * @param confirmPasswordInputId - string - input confirm password id
	 */
	validationConfirmPasswordInput(formId, passwordInputId, confirmPasswordInputId) {
		const form = document.querySelector(formId);
		const inputElement = document.querySelector(confirmPasswordInputId);
		const newPasswordInput = document.querySelector(passwordInputId);

		if(inputElement.dataset.showCriteria){
			return;
		}

		ValidationInput.disableSubmitBtn(form.id);
		
		inputElement.addEventListener('blur', (event) => {
			if (event.target.value.length !== 0) {
				ValidationInput.checkMismatchInput(event.target, newPasswordInput.value, form.id);
			} else {
				ValidationInput.validateInput(event.target, form.id);
			}
		});
		
		inputElement.addEventListener('invalid', (event) => {
			ValidationInput.resetInput(event.target);
		});
	}
	
	/**
	 * reset all form
	 * @param formId - string
	 */
	resetForm(formId) {
		const form = document.querySelector(formId);
		form.reset();
	}
	
	/**
	 * submit form with Google captcha
	 * @param formId - string
	 * @param route - string
	 * @param loaderId - string
	 * @param formName - string
	 * @param closeModal - boolean - define if a modal needs to be closed after success
	 * @param appendForm - Object - object of complementary field who needs to be appended in form
	 * @param hasSuccessMessage - boolean - define if form has a success message
	 * @param needConfirmationMessageContent - boolean - define if the form has the confirmation content rely on backend response
	 * @param needRecaptcha -boolean - if there is a need of google recaptcha
	 */
	submitForm(formId, route, loaderId, formName, appendForm = null, closeModal = false, hasSuccessMessage = false, needConfirmationMessageContent = false, needRecaptcha = false) {
		const form = document.querySelector(formId);
		form.addEventListener('submit', (event) => {
			event.preventDefault();
			
			LoadRecaptcha.loadRecaptcha(GlobalError, formId, needRecaptcha, function () {
				
				const selectedLocale = document.querySelector('#dropdownlanguageMenu');
				
				const loader = document.querySelector(loaderId);
				loader.classList.remove('d-none');
				
				const checkboxList = form.querySelectorAll('input[type="checkbox"]');
				checkboxList.forEach(function (checkbox) {
					checkbox.value = checkbox.checked ? 1 : 0;
				});
				const formData = new FormData(event.target);
				formData.append("from", formName);
				
				if (appendForm) {
					Object.entries(appendForm).forEach(([name, value]) => {
						formData.append(name, value);
					})
				}
				
				const messageSuccess = document.querySelector(`.msg-success-${ form.id }`);
				
				axios.post(`/${ selectedLocale.dataset.languageSelected }/${ route }`, Object.fromEntries(formData))
					.then((response) => {
						form.reset();
						const inputs = form.querySelectorAll('input');
						inputs.forEach((input) => {
							input.classList.remove('was-validated');
						})
						
						if (hasSuccessMessage) {
							messageSuccess.classList.remove('d-none');
							messageSuccess.classList.add('d-block');
							form.classList.add('d-none');
							if (messageSuccess) {
								const iconSuccess = messageSuccess.querySelector('.icon-success');
								iconSuccess.classList.remove('d-none');
								iconSuccess.classList.add('d-block');
							}
						}
						
						if (needConfirmationMessageContent && (response.data.data && response.data.data.modalContent)) {
							form.classList.add('d-none');
							if (messageSuccess) {
								messageSuccess.classList.remove('d-none');
								messageSuccess.classList.add('d-block');
								const successMessageContent = messageSuccess.querySelector('.success-message');
								successMessageContent.innerHTML = response.data.data.modalContent;
							}
						}
						
						if (closeModal) {
							const modal = form.closest('.modal');
							$('#' + modal.id).modal('hide');
						}
					})
					.catch(function (error) {
						loader.classList.add('d-none');
						if (error.response && error.response.data.errors) {
							if (error.response.data.errors.errorDetails) {
								if (error.response.data.errors.errorDetails.captcha) {
									const form = document.querySelector(formId);
									const captchaErrorElement = document.querySelector(`.captcha-error-${ form.id }`);
									captchaErrorElement.style.display = 'block';
									captchaErrorElement.textContent = error.response.data.errors.errorDetails.captcha;
								} else {
									Object.entries(error.response.data.errors.errorDetails).forEach(([inputkey, inputName]) => {
										const inputError = document.querySelector(`#${ form.id } [name=${ inputkey }]`);
										let errorElement = null;

										// Getting the right string to show up
										if(inputError.dataset.showCriteria){
											errorElement = document.querySelector(`.back-error-${ inputError.id }`);
											errorElement.classList.remove('d-none');
											errorElement.classList.add('d-flex');
										} else {
											errorElement = document.querySelector(`.invalid-feedback.error-${inputError.id}`);
										}

										inputError.classList.add('is-invalid');
										errorElement.textContent = typeof inputName === 'string' ? inputName : Object.values(inputName);

										// Adding the error mark
										if(inputError.dataset.showCriteria) {
											const icon = document.createElement('i');
											icon.className = 'fa-kit fa-cross';
											icon.style.color = 'var(--variant-6)';
											errorElement.insertBefore(icon, errorElement.firstChild);
											errorElement.insertBefore(document.createTextNode(' '), icon.nextSibling);
										}
									})
								}
								
								const inputList = form.querySelectorAll('input');
								inputList.forEach((input) => {
									if (input.classList.contains('was-validated')) {
										input.classList.remove('was-validated');
									}
								})
							} else {
								if (hasSuccessMessage) {
									form.classList.add('d-none');
									if (messageSuccess) {
										const iconFailure = messageSuccess.querySelector('.icon-failure');
										const successMessageContent = messageSuccess.querySelector('.success-message');
										successMessageContent.innerHTML = error.response.data.errors.message;
										iconFailure.classList.remove('d-none');
										iconFailure.classList.add('d-block');
									}
									
								} else {
									GlobalError.openErrorModal(error.response.data.errors.message, 'globalFormError');
								}
							}
						}
					})
					.finally(function () {
						loader.classList.add('d-none');
					});
				
			});
			
		});
		
	}
	
}



